module.exports = __webpack_public_path__ + "img/flag-POLAND.b04210ac.svg";